import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Patientfield } from "@app/definitions/types"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { SafeHtmlPipe } from "@app/utils/safe-html.pipe"

@Component({
	selector: "app-patient-field-tbl",
	imports: [COMMON_IMPORTS, GenInputComponent, LangValPipe, SafeHtmlPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div>
			<app-gen-input
				[actualObj]="this"
				fieldName="searchStr"
				(keyupEvent)="toShown()"
			/>
		</div>
		<div class="table-responsive">
			<table class="table table-striped table-hover pad-block">
				<thead>
					<tr>
						@for (field of ["name", "id_number"]; track field) {
							<th>{{ field | langVal }}</th>
						}
						@for (patientfield of patientfields; track patientfield) {
							<th>{{ patientfield.name }}</th>
						}
					</tr>
				</thead>
				<tbody>
					@for (row of rowsShown; track row) {
						<tr>
							@for (patientfield of searchFields; track patientfield) {
								<td
									[innerHtml]="
										row[patientfield + '_marked'] || row[patientfield] || ''
											| safeHtml
									"
								></td>
							}
						</tr>
					}
				</tbody>
			</table>
		</div>
	`,
})
export class PatientFieldTblComponent extends Modalable {
	rows: any[] = []
	rowsShown: any[] = []
	patientfields: Patientfield[] = []
	searchStr: string = ""
	searchFields: string[] = []

	async ngOnInit() {
		this.patientfields = this.store.getPreppedPatientFields()
		this.searchFields = [
			"name",
			"id_number",
			...this.patientfields.map((it) => "patientfield_id_" + it.id),
		]
		const res: any = await this.apiService.post("get_patient_fields_tbl")
		this.rows = res.patients
		this.store.removeDecArr(this.rows)
		this.toShown()
	}

	toShown() {
		this.rowsShown = [...this.rows]
		if (this.searchStr) {
			this.rowsShown = this.rowsShown.filter((r) =>
				this.searchFields.some((f) => r[f] && r[f].includes(this.searchStr))
			)
		}
		this.rowsShown.forEach((r) =>
			this.store.markInObj(r, this.searchFields, this.searchStr)
		)
	}
}
